export const processNextTealiumTags = async function (nextPage, pageNumber, isSubmit) {
    let linkObject = {
        "event_action": "User click",
        "event_category": "Enquiry Button",
        "event_label": nextPage,
        "event_type": "Footer",
        "form_step": pageNumber,
        "form_step_name": nextPage,
        "page_type": "services",
        "site_section": "services",
        "tealium_event": isSubmit ? "form_submit" : "forward_page_turn"
    }

    utag.link(linkObject);
};

export const processPreviousTealiumTags = async function (previousPage, pageNumber) {
    let linkObject = {
        "event_action": "User click",
        "event_category": "Enquiry Button",
        "event_label": previousPage,
        "event_type": "Footer",
        "form_step": pageNumber,
        "form_step_name": previousPage,
        "page_type": "services",
        "site_section": "services",
        "tealium_event": "backward_page_turn"
    };

    utag.link(linkObject);
};


export const getTealiumID = () =>
    typeof window !== 'undefined' &&
    typeof window.utag === 'object' &&
    typeof window.utag.data === 'object'
    ? window.utag.data.tealium_visitor_id
    : null;
